import React, { useRef, useState } from 'react';
import { Dropdown } from 'antd';
import { useTranslation } from 'react-i18next';
import Creators from '../../CollectionsPage/reducer';
import { useDispatch, useSelector } from 'react-redux';
import acc from 'accounting';
import IconWithText from '../../../Components/Text';
import Icon from '../../../Icon';
import DeleteModal from '../../CollectionsModals/components/modals/delete-modal';
import RenameModal from '../../CollectionsModals/components/modals/rename-modal';
import './CollectionsStats.less';

const CollectionsStats = (
  {
    collectionID = '',
    products,
  }) => {

  const { t } = useTranslation();
  const dropdown = useRef(null);
  const dispatch = useDispatch();

  const isMobile = useSelector(state => state?.nav?.isMobile);
  const loading = useSelector(state => state.collections.loading);
  const collections = useSelector(state => state?.collections?.collections?.results) || [];
  const collection = collections.filter(el => el?.id === collectionID)?.[0];

  const [visible, setVisible] = useState(false);
  const [modal, setModal] = useState(null);

  const average = products?.length ? products.reduce((a, b) => a + +b?.price, 0) / products?.length : 0;
  const minimum = products?.length ? Math.min(...products.map(el => +el?.price)) : 0;
  const maximum = products?.length ? Math.max(...products.map(el => +el?.price)) : 0;


  return (
    <div className={'collections-stats-wrapper'}>
      <div className={'collections-stats-title-wrapper'}>
        <span className={'collections-stats-title'}>
          {collection?.name}
        </span>
        {
          collection?.general ?
            null
            :
            <div ref={dropdown}
                 className={'collections-page-list-item-info-action'}
            >
              <Dropdown placement="bottomRight"
                        getPopupContainer={() => dropdown.current}
                        destroyPopupOnHide={true}
                        open={visible}
                        onOpenChange={(flag) => {
                          setVisible(flag);
                        }}
                        dropdownRender={() => (
                          <ul className="action-dropdown">
                            <li className="action-dropdown-item"
                                onClick={() => {
                                  setVisible(false);
                                  setModal('collection_rename');
                                }}
                            >
                              <IconWithText text={t('Rename')}
                                            size={24}
                                            icon={() => <Icon type="rename_collection" role="icon" />}
                              />
                            </li>
                            <li className="action-dropdown-item red"
                                onClick={() => {
                                  setVisible(false);
                                  setModal('collection_delete');
                                }}
                            >
                              <IconWithText text={t('Remove')}
                                            size={24}
                                            icon={() => <Icon type="trash" role="icon" />}
                              />
                            </li>
                          </ul>
                        )}
                        trigger={['click']}
              >
                <span onClick={(e) => {
                  e.preventDefault();
                }}
                >
                  <Icon type="three_dots" role="icon" />
                </span>
              </Dropdown>
            </div>
        }
      </div>
      <div className={'collections-stats'}>
        <div className="collections-stat">
          <span className="title">
            {t('Products')}
          </span>
          <span className="value">
            {acc.formatNumber(products?.length, 0, '', '')}
          </span>
        </div>
        <div className="collections-stat">
          <span className="title">
            {t('Average')}
          </span>
          <span className="value">
            ${acc.formatNumber(average || 0, 2, '.', ',')}
          </span>
        </div>
        <div className="collections-stat">
          <span className="title">
            {t('Minimum')}
          </span>
          <span className="value">
            ${acc.formatNumber(minimum || 0, 2, '.', ',')}
          </span>
        </div>
        <div className="collections-stat">
          <span className="title">
            {t('Maximum')}
          </span>
          <span className="value">
            ${acc.formatNumber(maximum || 0, 2, '.', ',')}
          </span>
        </div>
      </div>
      <DeleteModal setModal={setModal}
                   isMobile={isMobile}
                   modal={modal}
                   loading={loading}
                   removeCollection={(id) => dispatch(Creators.removeCollectionRequest({ collectionID: id }))}
                   collection={collection}
      />
      <RenameModal setModal={setModal}
                   isMobile={isMobile}
                   modal={modal}
                   renameCollection={(id, name) => dispatch(Creators.renameCollectionRequest({
                     collectionID: id,
                     collectionName: name,
                   }))}
                   collection={collection}
      />
    </div>
  );
};

export default CollectionsStats;
